/* eslint-disable no-restricted-syntax */

import Immutable from 'immutable';
import { ADD_SUBSCRIPTIONS, UPDATE_SUBSCRIPTION_AS_READ } from './actions';
import {
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
  NOTIFICATION_RESET,
} from '../Notifications/actions';
import { FETCH_NOTIFICATION_DETAIL_SUCCESS } from '../PushNotification/actions';
import { GET_LINKED_NOTIFICATION_DATA } from '../LinkedNotification/actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';

const INITIAL_STATE = Immutable.fromJS({
  byId: {},
  byChannel: {}, // And then a map indexes by endEventIndex
});

export function Subscriptions(state = INITIAL_STATE, action) {
  switch (action.type) {
    case NOTIFICATION_READ_FETCH_SUCCESS:
    case NOTIFICATION_READ_REFRESH_SUCCESS:
    case NOTIFICATION_READ_LOAD_MORE_SUCCESS:
    case NOTIFICATION_UNREAD_FETCH_SUCCESS:
    case NOTIFICATION_UNREAD_REFRESH_SUCCESS:
    case NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS:
    case GET_LINKED_NOTIFICATION_DATA:
    case ADD_SUBSCRIPTIONS:
    case FETCH_NOTIFICATION_DETAIL_SUCCESS: {
      const subscriptions = Immutable.fromJS(action.subscriptions);
      let updatedState = state;
      // only left the read notification
      if (action.type === NOTIFICATION_UNREAD_REFRESH_SUCCESS) {
        const updatedStateById = updatedState
          .get('byId')
          .filter((x) => x.get('isRead') === true);
        let updatedStateByChannel = Immutable.Map();

        updatedState.get('byChannel').map((values) => {
          return values.map((value) => {
            if (value.get('isRead') === true) {
              return (updatedStateByChannel = updatedStateByChannel.setIn(
                [value.get('channelId'), value.get('endEventIndex')],
                value
              ));
            } else {
              return value;
            }
          });
        });

        updatedState = updatedState.set('byId', updatedStateById);
        updatedState = updatedState.set('byChannel', updatedStateByChannel);
      }

      for (const subscription of subscriptions.values()) {
        updatedState = updatedState.setIn(
          ['byId', subscription.get('id')],
          subscription
        );
        updatedState = updatedState.setIn(
          [
            'byChannel',
            subscription.get('channelId'),
            subscription.get('endEventIndex'),
          ],
          subscription
        );
      }
      return updatedState;
    }
    case UPDATE_SUBSCRIPTION_AS_READ: {
      const { subscriptionId, lastCheckedEventIndex } = action;
      return state
        .setIn(['byId', subscriptionId, 'isRead'], true)
        .setIn(
          ['byId', subscriptionId, 'lastCheckedEventIndex'],
          lastCheckedEventIndex
        );
    }
    case NOTIFICATION_RESET:
    case LOGOUT_SUCCESS: {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
}
